export default "__VITE_ASSET__CKeXHwhk__"